import { compose } from '@reduxjs/toolkit';
import { createYapePromotionReducer } from './createYapePromotion';
import { editYapePromotionReducer } from './editYapePromotion';
import { fetchYapePromotionListReducer } from './fetchYapePromotionList';
import { fetchYapeQrListReducer } from './fetchYapeQrList';
import { uploadClientListReducer } from './uploadClientList';

export const extraReducers = compose(
  createYapePromotionReducer,
  editYapePromotionReducer,
  fetchYapePromotionListReducer,
  fetchYapeQrListReducer,
  uploadClientListReducer,
);

export { createYapePromotion } from './createYapePromotion';
export { editYapePromotion } from './editYapePromotion';
export { fetchYapePromotionList } from './fetchYapePromotionList';
export { fetchYapeQrList } from './fetchYapeQrList';
export { uploadClientList } from './uploadClientList';
